/* eslint-disable @typescript-eslint/no-unsafe-call */
export const getTranslations =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (translations: any) =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (language: string, key: string, format: any = null): string => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const messages = translations.getLoadedMessages(language);

      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
      return messages ? messages[key].format(format) : 'Error';
    };
